import { HELP_CENTER_ROUTE } from '@portals/portal-routes';
import { computeCurrentZone, resolveUrl } from '@portal-root/geo-utils';
import {
  CATEGORY_PATH,
  MATERIAL_PATH,
  CATEGORIES_PATH,
} from '@/_constants/routes';

const REGEXP = /^(https?:\/\/[^/]+)(\/[^?#]*)?(\?[^#]*)?(#.*)?$/;

const getExternalPathname = (pathname: string): string => {
  const [, root, ...path] = pathname.split('/');

  if (root !== HELP_CENTER_ROUTE.routeName) {
    return pathname;
  }

  const [firstPath, ...restPath] = path;
  if (firstPath === HELP_CENTER_ROUTE.children.category.routeName) {
    return [CATEGORY_PATH, ...restPath].join('/');
  }

  if (firstPath === HELP_CENTER_ROUTE.children.categories.routeName) {
    return CATEGORIES_PATH;
  }

  if (firstPath === HELP_CENTER_ROUTE.children.article.routeName) {
    return [MATERIAL_PATH, ...restPath].join('/');
  }

  return pathname;
};

export const getExternalFromExternalUrl = (
  url: string,
  host?: string,
): string => {
  const matches = url.match(REGEXP);
  if (!matches) {
    return url;
  }

  const origin = matches[1];
  const pathname = matches[2] || '';
  const searchParams = matches[3] || '';
  const hash = matches[4] || '';

  const externalPathname = getExternalPathname(pathname);

  const isSamePathName = externalPathname === pathname;

  const currentZone = computeCurrentZone(host || '');

  if (isSamePathName) {
    return resolveUrl(url, currentZone);
  }

  // CI_TMPL_HELM_CUSTOM_NEXT_PUBLISHED_URL тут не подходит, потому что нет NEXT_PUBLIC префикса
  return resolveUrl(
    `${origin}${process.env.NEXT_PUBLIC_PUBLISHED_URL}${externalPathname}${searchParams}${hash}`,
    currentZone,
  );
};
